module.exports = __webpack_public_path__ + "img/symbol_login_kakao.bef8a338.svg";